<template>
  <div ref="root" class="china-address-cascader">
    <button type="button" class="address-trigger" :class="{ placeholder: !value }" @click="toggle">
      <span>{{ value || placeholder }}</span><i>⌄</i>
    </button>
    <div v-if="visible" class="address-panel">
      <div class="address-column">
        <button v-for="name in provinces" :key="name" type="button" :class="{ active: selected.province === name }" @click="selectProvince(name)"><span>{{ name }}</span><i>›</i></button>
      </div>
      <div v-if="selected.province" class="address-column">
        <button v-for="name in cities" :key="name" type="button" :class="{ active: selected.city === name }" @click="selectCity(name)"><span>{{ name }}</span><i>›</i></button>
      </div>
      <div v-if="selected.city" class="address-column">
        <button v-for="name in areas" :key="name" type="button" :class="{ active: selected.area === name }" @click="selectArea(name)"><span>{{ name }}</span><i>›</i></button>
      </div>
      <div v-if="selected.area" class="address-column">
        <button v-for="name in streets" :key="name" type="button" :class="{ active: selected.street === name }" @click="selectStreet(name)"><span>{{ name }}</span></button>
      </div>
      <div v-if="loading" class="address-loading">地址数据加载中...</div>
    </div>
  </div>
</template>

<script>
let addressDataPromise

function loadAddressData() {
  if (!addressDataPromise) {
    const base = process.env.BASE_URL || '/'
    addressDataPromise = fetch(`${base}data/china-pcas.json`).then(response => {
      if (!response.ok) throw new Error('地址数据加载失败')
      return response.json()
    })
  }
  return addressDataPromise
}

export default {
  name: 'ChinaAddressCascader',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '请选择省、市、区/县、街道' }
  },
  data() {
    return {
      visible: false,
      loading: false,
      addressData: {},
      selected: { province: '', city: '', area: '', street: '' }
    }
  },
  computed: {
    provinces() { return Object.keys(this.addressData) },
    cities() { return this.selected.province ? Object.keys(this.addressData[this.selected.province] || {}) : [] },
    areas() { return this.selected.city ? Object.keys((this.addressData[this.selected.province] || {})[this.selected.city] || {}) : [] },
    streets() { return this.selected.area ? (((this.addressData[this.selected.province] || {})[this.selected.city] || {})[this.selected.area] || []) : [] }
  },
  watch: {
    value() { this.restoreValue() }
  },
  mounted() {
    document.addEventListener('click', this.handleOutside)
    this.ensureData()
  },
  beforeDestroy() { document.removeEventListener('click', this.handleOutside) },
  methods: {
    ensureData() {
      if (this.provinces.length) return Promise.resolve()
      this.loading = true
      return loadAddressData().then(data => { this.addressData = data || {}; this.restoreValue() }).catch(error => { this.$emit('error', error) }).finally(() => { this.loading = false })
    },
    toggle() { this.visible = !this.visible; if (this.visible) this.ensureData() },
    handleOutside(event) { if (this.visible && this.$refs.root && !this.$refs.root.contains(event.target)) this.visible = false },
    restoreValue() {
      if (!this.value) {
        this.selected = { province: '', city: '', area: '', street: '' }
        return
      }
      if (!this.provinces.length) return
      const parts = this.value.split(/\s+/).filter(Boolean)
      if (!parts.length || !this.addressData[parts[0]]) return
      this.selected = { province: parts[0] || '', city: parts[1] || '', area: parts[2] || '', street: parts.slice(3).join(' ') || '' }
    },
    selectProvince(name) { this.selected = { province: name, city: '', area: '', street: '' } },
    selectCity(name) { this.selected = { ...this.selected, city: name, area: '', street: '' } },
    selectArea(name) { this.selected = { ...this.selected, area: name, street: '' } },
    selectStreet(name) {
      this.selected.street = name
      this.$emit('input', [this.selected.province, this.selected.city, this.selected.area, name].filter(Boolean).join(' '))
      this.$emit('change', { ...this.selected })
      this.visible = false
    }
  }
}
</script>

<style scoped>
.china-address-cascader { position: relative; min-width: 0; }
.address-trigger { width: 100%; height: 34px; padding: 0 10px; border: 1px solid #d2d8e1; display: flex; align-items: center; justify-content: space-between; background: #fff; color: #334155; text-align: left; cursor: pointer; box-sizing: border-box; }
.address-trigger.placeholder { color: #a0a9b7; }.address-trigger i { color: #64748b; font-style: normal; }
.address-panel { position: absolute; z-index: 80; top: 38px; left: 0; min-width: 168px; display: flex; border: 1px solid #d7dde7; border-radius: 5px; background: #fff; box-shadow: 0 8px 24px rgba(15, 23, 42, .16); }
.address-column { width: 168px; max-height: 250px; padding: 4px 0; overflow-y: auto; border-right: 1px solid #edf0f4; box-sizing: border-box; }
.address-column:last-child { border-right: 0; }.address-column::-webkit-scrollbar { width: 3px; }.address-column::-webkit-scrollbar-thumb { border-radius: 3px; background: #aeb8c5; }
.address-column button { width: 100%; min-height: 34px; padding: 6px 10px; border: 0; display: flex; align-items: center; justify-content: space-between; background: #fff; color: #334155; text-align: left; cursor: pointer; }
.address-column button:hover, .address-column button.active { background: #edf6ff; color: #1684ff; }.address-column i { color: #94a3b8; font-style: normal; }
.address-loading { width: 168px; padding: 20px 10px; color: #94a3b8; text-align: center; }
</style>
